module.exports = __webpack_public_path__ + "img/Enston-logo.671c01bf.png";